const {REACT_APP_BASE_URL}=process.env
export const baseUrl = REACT_APP_BASE_URL;

export const headers = {
    "Content-Type": "application/json",
}

export const jwtHeaders = () => {
    const headers = {
        "Content-Type": "application/json",
        // "Authorization": `Bearer ${JSON.parse(localStorage.getItem("salon-superAdmin"))?.token}`,
    }
    return headers;
}

export const logoutUtil = () => {
    window.location.href = "/login";
};